<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  extends: Editor,

  props: {
    apiKey: {
      type: String,
      // default: config('tinymce.api_key'),
      // for self-hosted usage
      default: '',
    },
    plugins: {
      type: Array,
      default: function () {
        return [
          'wordcount',
          'link',
          'lists',
          'code',
          'image',
        ];
      },
    },
    menubar: {
      type: Boolean,
      default: false,
    },
    toolbar: {
      type: Array,
      default: function () {
        return [
          'undo redo | fontsizeselect fontselect | alignleft aligncenter alignright alignjustify | 2 h3 h4 h5 | bold italic underline strikethrough | bullist numlist | link | image',
        ];
      },
    },
    init: {
      type: Object,
      default: function () {
        return {
          menubar: false,
          height: 300,
          valid_styles: {'*': ''},
          // for self-hosted usage
          skin_url: '/vendor/tinymce/skins/ui/oxide',
          // for self-hosted usage
          content_css: '/vendor/tinymce/skins/content/default/content.min.css',
        };
      },
    },
  },
}
</script>
